import React, { useState } from "react"
import axios from "axios"
import {
  Link,
  useNavigate
} from "react-router-dom"

const API = "https://food-backend-9733.onrender.com"

const Reg = () => {
  const [data, setData] = useState({
    email: "",
    name: "",
    pwd: "",
    phone: ""
  })

  const [msg, setMsg] = useState("")
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate()

  const handleChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value
    })
    setMsg("")
  }

  const register = () => {
    if (!data.email || !data.name || !data.pwd) {
      setMsg("Name, email and password are required")
      return
    }

    setLoading(true)

    axios.post(`${API}/reguser`, data)
      .then(() => {
        navigate("/login")
      })
      .catch(err => {
        setMsg(
          err.response?.data?.msg ||
          "Registration failed"
        )
      })
      .finally(() => setLoading(false))
  }

  return (
    <main className="auth-page">
      <section className="auth-shell auth-shell-reverse">
        <div className="auth-card">
          <span className="auth-kicker">
            Create Account
          </span>

          <h2>Sign Up</h2>

          <p className="auth-subtitle">
            Save your details for faster checkout and live order tracking.
          </p>

          <div className="auth-form">
            <label className="auth-field">
              <span>Full Name</span>
              <input
                type="text"
                name="name"
                placeholder="Enter your name"
                value={data.name}
                onChange={handleChange}
              />
            </label>

            <label className="auth-field">
              <span>Email</span>
              <input
                type="email"
                name="email"
                placeholder="Enter email address"
                value={data.email}
                onChange={handleChange}
              />
            </label>

            <label className="auth-field">
              <span>Phone</span>
              <input
                type="text"
                name="phone"
                placeholder="Enter phone number"
                value={data.phone}
                onChange={handleChange}
              />
            </label>

            <label className="auth-field">
              <span>Password</span>
              <input
                type="password"
                name="pwd"
                placeholder="Create password"
                value={data.pwd}
                onChange={handleChange}
              />
            </label>

            <button
              type="button"
              className="auth-primary-btn"
              onClick={register}
              disabled={loading}
            >
              {loading ? "Creating..." : "Create Account"}
            </button>

            <p className="auth-inline-link">
              Already registered? <Link to="/login">Login</Link>
            </p>

            {msg && (
              <p className="auth-message">
                {msg}
              </p>
            )}
          </div>
        </div>

        <div className="auth-visual">
          <img
            src="/48hours.jpg"
            alt="Fresh homemade specials"
          />

          <div className="auth-visual-overlay">
            <span>Limited Fresh Batches</span>
            <h1>Order homemade snacks, sweets and specials with confidence.</h1>
            <p>
              Create an account to manage profile, cart, requirements and
              delivery details.
            </p>
          </div>
        </div>
      </section>
    </main>
  )
}

export default Reg
